export default "__VITE_ASSET__97f76b85__"